module.exports = {
          srcSet: __webpack_public_path__ + "c01ca2a2690acab61276dde0523666b7-97.png"+" 97w",
          images:[ {path: __webpack_public_path__ + "c01ca2a2690acab61276dde0523666b7-97.png",width: 97,height: 90}],
          src: __webpack_public_path__ + "c01ca2a2690acab61276dde0523666b7-97.png",
          toString:function(){return __webpack_public_path__ + "c01ca2a2690acab61276dde0523666b7-97.png"},
          
          width: 97,
          height: 90
        }